export const translations = {
  'home': {
    'free': 'Free1'
  },
  'playNarration': 'Presiona Play para comenzar la narración',
  "supportSonamaInfo":{
    "supportHead":"Apoye la historia de Sonoma Plaza",
    "donateNow":"Done ahora",
    "mailingList":"Únete a nuestra lista de correos"
  },
  'loadingStop' : {
    'loadingTourStop': 'Cargando parada de viaje',
    'forBestExperience': 'Para la mejor experiencia...',
    'wiFiIsTurnedOff': 'Asegúrate de que el wifi externo local esté apagado',
    'loadingTour': 'Haz clic para continuar'
  },
  'welcomePage':{
    'free':"libre",
    'walking':"caminando",
    'devices':'dispositivos',
    '1Hour':'1 hora',
    'welcomeTo':'Bienvenido al Recorrido Histórico de la Plaza de Sonoma',
    'weAreSo':'Nos encanta que nos acompañes en esta aventura a través del tiempo.',
    'chooseYour':'Elige tu punto de partida',
    'launchFirst':'Inicia la primera parada',
    'ourFirst':'Nuestra primera parada se ubica en la Alcaldía',
    'jumpTo':'Salta a cualquier destino',
    'pickUp':'Continúa donde estabas.',
    'tourInformation':'Información del Recorrido',
    'location':'Lugar - Plaza de Sonoma',
    'allDestinations':'Todos los destinos de este recorrido se encuentran a poca distancia a pie de Sonoma Plaza, ubicado en',
    'plazaSonama':'1 Plaza, Sonoma',
    'deviceAccess':'Acceso en dispositivo',
    'thisAWeb':'Esta es una aplicación en línea a la que puedes acceder desde cualquier dispositivo  móvil con conexión a internet o computador de escritorio a través de un navegador web.',
    'parking':'Estacionamiento',
    'forWalking':'Para el recorrido a pie, asegúrate de haber estacionado alrededor de la Plaza de Sonoma y caminar a tu destino.',
    'moreInformation':'Más información proximamente'
  },
  'chooseStop':{
    'back':' Regresa a la pantalla de inicio.',
    'new':'¡NUEVO!',
    'jumpTo':'Adelanta a cualquier parada',
    'stop':'Parada',
    'launch': 'Iniciar'
  },
  'stopCard': {
    'nextStop': 'PRÓXIMA PARADA',
    'arrivedButton': "He llegado",
    'continueButton': 'Continuar'
  },
  'sideNavBar': {
    'home': 'Hogar',
    'allStops': 'Lista de todas las paradas',
    'troubleshooting': 'Solución de problemas',
    'donate': 'Donar',
    'exitTour': 'Tour de salida'
  }

}
